import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/Swalokrbg.png";

const AdminSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed); // Toggle the sidebar collapsed state
  };

  return (
    <>
      <section className={`dashboard-sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="text-center overflow-y-auto">
          <img src={Logo} className="sidebar-logo mb-4" alt="sidebar logo" />

          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/dashboard")}
          >
            <i className="fa-solid fa-house"></i> Dashboard
          </p>
          {/* <p className="sidebar-btn" onClick={() => navigate("/admin/profile")}>
            <i className="fa-solid fa-user"></i> Manage Profile
          </p> */}
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/add-plot")}
          >
            <i className="fa-solid fa-building"></i> Add Plot
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/plot-inventory")}
          >
            <i className="fa-solid fa-rectangle-list"></i> Inventory
          </p>
          <p className="sidebar-btn" onClick={() => navigate("/admin/team")}>
            <i className="fa-solid fa-users"></i> Team
          </p>
          <p className="sidebar-btn" onClick={() => navigate("/admin/reports")}>
            <i className="fa-solid fa-clipboard"></i> Daily Reports
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/add-sale")}
          >
            <i className="fa-solid fa-clock"></i> Add Sale
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/sale-history")}
          >
            <i className="fa-solid fa-clock-rotate-left"></i> Sale History
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/manage-dues")}
          >
            <i className="fa-solid fa-wallet"></i> Manage Dues
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/add-sites")}
          >
            <i className="fa-solid fa-clipboard"></i> List New Site
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/team-rewards")}
          >
            <i className="fa-solid fa-award"></i> Team Rewards
          </p>
          <p
            className="sidebar-btn"
            onClick={() => navigate("/admin/blogs-posted")}
          >
            <i className="fa-solid fa-pen-nib"></i> Blog History
          </p>
          <p className="sidebar-btn" onClick={handleLogout}>
            <i className="fa-solid fa-right-from-bracket"></i> Logout
          </p>
        </div>

        <button
          className="w-auto sidebar-btn2 float-end"
          onClick={toggleSidebar}
        >
          <i
            className={`fa-solid ${
              collapsed ? "fa-angle-left" : "fa-angle-right"
            }`}
          ></i>
        </button>
      </section>

      {/* <nav className={`navbar navbar-expand-lg sticky-top ${isScrolled ? 'bg-white shadow-sm' : ''}`}>
                <div className="container">
                    <Link className="navbar-brand py-0" to='/'><img src={Logo} className='img-fluid' alt='Site Logo' style={{height: '3.5em'}} /></Link>
                    <button className="navbar-toggler" onClick={() => setIsCollapsed(!isCollapsed)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fa-solid fa-bars"></i>
                    </button>
                    <div className={`collapse navbar-collapse justify-content-center ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeclassname="active" onClick={handleLinkClick} to='/admin/dashboard'>Dashboard</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeclassname="active" onClick={handleLinkClick} to='/admin/team'>Team</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeclassname="active" onClick={handleLinkClick} to='/admin/reports'>Daily Reports</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeclassname="active" onClick={handleLinkClick} to='/admin/meetings'>Meetings History</NavLink>
                            </li>
                            <li className="nav-item my-3">
                                <NavLink className="nav-text" activeclassname="active" onClick={handleLinkClick} to='/admin/reward-history'>Rewards History</NavLink>
                            </li>
                            <li className="nav-item my-2">
                                <button className="admin-btn py-2 px-3 fw-light" activeclassname="active" onClick={handleLogout}>Logout&nbsp; <i className="fa-solid fa-right-from-bracket"></i></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav> */}
    </>
  );
};

export default AdminSidebar;
